<template>
   <div class="container-fluid layout-page">
      <h2 class="ml-bk-corp ml-white title-block marb-12">New Appointment Application:</h2>

      <div class="wizpage">
         <!-- === STEP 1 === -->
         <div class="step step-1 active" v-if="curstep == 1">
            <div class="row mart-12">
               <div class="col-9">
                  <h3>Instructions</h3>
                  <div v-if="!invitationLoaded">
                     <i class="fas fa-spinner fa-spin fa-2x"></i>
                  </div>
                  <div v-else>
                     <div v-if="isVBInvitation">
                        <p>
                           <b>Welcome!</b>
                           <br />
                           <br />
                           This step-by-step wizard will guide you through confirming your invitation, setting up your contracting and appointment, and providing the information and documents needed for approval.
                           <br />
                           <br />
                           Click <b>Next</b> to get started.
                        </p>
                     </div>
                     <div v-else>
                        <p>
                           Welcome! These instructions will help you create a new appointment application
                           of the correct type and walk you through filling it out.
                        </p>

                        <p v-if="already">
                           Since you have already been appointed successfully in the past, this
                           application process will be abbreviated.
                        </p>
                        <p v-else>
                           Since you are new to the {{ appName }} system, we will guide you through the
                           process step by step to gather the information and documents that are needed to
                           get your appointment approved quickly.
                        </p>

                        <p>
                           This wizard will confirm that the Invitation that was sent to you is correct.
                           On each step please review and click the Next button when ready. Click the Next
                           button now to begin.
                        </p>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <!-- === STEP 2 === -->
         <div class="step step-1 active" v-if="curstep == 2">
            <div class="row mart-12">
               <div class="col-9">
                  <h3>The Invitation</h3>

                  <p>
                     The invitation you've responded to for becoming appointed was from the
                     following agency:
                  </p>

                  <div v-if="step2 != {}">
                     <div v-if="isVBInvitation">
                        <!-- for VB contracting agents-->
                        <div class="indent">VB Contracting</div>
                     </div>
                     <div v-else >
                        <div class="indent">{{ this.recruiterName }}</div>
                        <div class="indent">{{ this.step2.agent.address1 }}</div>
                        <div class="indent" v-if="this.step2.agent.address2 != ''">
                           {{ this.step2.agent.address2 }}
                        </div>
                        <div class="indent">
                           {{ this.step2.agent.city }}, {{ this.step2.agent.state }}&nbsp;&nbsp;{{
                              this.step2.agent.zip
                           }}
                        </div>

                        <div v-if="isMulti">
                           <p class="mart-12">Appointments:</p>

                           <div class="indent" v-for="(itm, indx) in step2.multiLinks" :key="indx">
                              {{itm.carrier}} - Level {{itm.levelNo}}, {{itm.levelName}}
                           </div>
                        </div>
                        <div v-else>
                           <p class="mart-12">Position:</p>

                           <div class="indent">Level {{ this.step2.levelNo }}</div>
                           <div class="indent">{{ this.step2.levelName }}</div>
                        </div>
                     </div>
                  </div>
                  <div v-else>
                     <i class="fas fa-spinner fa-spin fa-2x"></i>
                  </div>

                  <p class="mart-12">Click the Next button to continue.</p>
               </div>
            </div>
         </div>

         <!-- === STEP 3 === -->
         <div class="step step-1 active" v-if="curstep == 3">
            <div class="row mart-12">
               <div class="col-9">
                  <h3>Type of Appointment</h3>

                  <p>
                     There are different types of appointments. Please carefully review the
                     descriptions below and choose the appropriate appointment type:
                  </p>

                  <!-- Appointment Types
                     APPTTYP_IND
                     APPTTYP_CORP
                     APPTTYP_REP
                     APPTTYP_BOTH
                  -->
                  <div class="marl-12 padb-12">
                     <div v-if="isVBInvitation" style="padding-left: 12px;">
                        <div class="custom-control custom-radio">
                           <input type="radio"
                                  id="atB"
                                  name="appointmentType"
                                  class="custom-control-input"
                                  :value="aptBoth"
                                  v-model="appointmentType" />
                           <label class="custom-control-label" for="atB">Individual Agent and Corporation</label>
                        </div>
                        <ul class="atype-list">
                           <li>You are an Individual Agent</li>
                           <li>You own an Agency/Corporation</li>
                        </ul>
                     </div>
                     <div class="marl-12 padb-12">
                        <div class="custom-control custom-radio">
                           <input type="radio"
                                  id="atI"
                                  name="appointmentType"
                                  class="custom-control-input"
                                  :value="aptInd"
                                  v-model="appointmentType" />
                           <label class="custom-control-label" for="atI">Individual Agent</label>
                        </div>
                        <ul class="atype-list">
                           <li>You are an Individual Agent</li>
                           <li>You hold Insurance license(s)</li>
                        </ul>

                        <div class="custom-control custom-radio">
                           <input type="radio"
                                  id="atC"
                                  name="appointmentType"
                                  class="custom-control-input"
                                  :value="aptCorp"
                                  v-model="appointmentType" />
                           <label class="custom-control-label" for="atC">Corporation</label>
                        </div>
                        <ul class="atype-list">
                           <li>You own an Agency/Corporation</li>
                           <li>Your Agency/Corporation holds Insurance License(s)</li>
                        </ul>
                     </div>
                     <!--<div v-if="isVBInvitation" style="padding-left: 12px;">
                        <div class="custom-control custom-radio">
                           <input type="radio"
                                  id="atR"
                                  name="appointmentType"
                                  class="custom-control-input"
                                  :value="aptVBRep"
                                  v-model="appointmentType" />
                           <label class="custom-control-label" for="atR">Representative</label>
                        </div>
                        <ul class="atype-list">
                           <li>You are an Individual Agent</li>
                           <li>You hold Insurance license(s)</li>
                        </ul>
                     </div>-->
                  </div>
               </div>
            </div>
         </div>

         <!-- === STEP 4 === -->
         <div class="step step-1 active" v-if="curstep == 4">
            <div class="row mart-12">
               <div class="col-9">
                  <h3>Filling Out Your Application</h3>

                  <p>
                     Here are a few pointers for filling out your application. You can choose to
                     skip this introduction if you already know how to do it.
                     <a href="#" @click.prevent="handleNext" class="skip-link font-smaller">(Skip to the Application)</a>. There are additional instructions in the application itself.
                  </p>

                  <div class="doc-view mart-12">
                     <div class="inner-doc-view">
                        <pdf-viewer docpath="Instructions.pdf" title="Instructions" :downloadfiletype="downloadfiletype" :keepdefaultcss="keepdefaultcss"></pdf-viewer>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>

      <div class="button-strip marb-24 padt-12">
         <div class="row">
            <!-- LEFT BTNs -->
            <div class="col-3">
               <div v-if="curstep == 1">
                  <router-link tag="button"
                               to="/home"
                               class="btn btn-md ml-btn wizbtn-back ml-h-orange">
                     <i class="fas fa-times"></i>
                     CANCEL
                  </router-link>
               </div>
               <div v-else>
                  <button class="btn btn-md ml-btn wizbtn-back ml-h-orange"
                          v-on:click="handlePrevious">
                     <i class="fas fa-arrow-left"></i>
                     PREVIOUS
                  </button>
               </div>
            </div>

            <div class="col-3 text-center">
               <wizstep v-bind:step="curstep"></wizstep>
            </div>

            <!-- RIGHT BTNs -->
            <div class="col-3 text-right">
               <button class="btn btn-md ml-btn wizbtn-next ml-h-orange" v-on:click="handleNext">
                  <span v-if="!busy">
                     NEXT
                     <i class="fas fa-arrow-right"></i>
                  </span>
                  <i class="fas fa-spinner fa-spin" v-else></i>
               </button>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
   import "bootstrap";
   import { mapGetters, mapMutations } from "vuex";
   import WizStep from "../components/WizStep.vue";
   import pdfViewer from "../components/appt/pdfViewer.vue"

   export default {
      name: "Wizard",
      components: {
         wizstep: WizStep,
         'pdf-viewer': pdfViewer
      },
      data() {
         return {
            curstep: 1,
            busy: false,
            already: false, //have they been appointed already before?
            appName: process.env.VUE_APP_TITLE,
            ynPicked: "Y",
            link: "",
            step2: {},
            recruiterName: "",
            appointmentType: "",
            isRep: false,
            loading: true,
            multiLinks: null,
            isMulti: false,
            downloadfiletype: 4,
            keepdefaultcss: false,
            aptInd: "",
            aptCorp: "",
            aptRep: "",
            aptBoth: "",
            aptVBRep: "APPTTYP_VB_REP",
            invitationLoaded: false
         };
      },
      computed: {
         ...mapGetters(["isVBInvitation"])
      },
      async mounted() {
         await this.initialize();
      },
      methods: {
         ...mapMutations(["updateEmailTemplateTypeId"]),
         async initialize() {
            this.curstep = 1;
            if (this.$route.params.multiLinkId) this.isMulti = true
            if (!this.$route.params.link && !this.isMulti) {
               this.$swal(
                  "System Error",
                  "Oops. Pardon our mistakes. Please start over from the home page...",
                  "error"
               );
               this.$router.push({ name: "home" });
               return;
            }

            if (this.isMulti) {
               this.multiLinks = this.$route.params.multiLinks
               this.link = this.multiLinks[0]
            } else {
               this.link = this.$route.params.link;
            }
            await this.loadInvite();
         },
         async loadInvite() {
            // At this point an invitation may or may not exist. If not, create it
            // Get information about the invitation
            let usr = this.$store.getters.appUser;
            let claims = this.$store.getters.userClaims;

            var payload = {
               request: {
                  link: this.link,
                  prospectFirstName: claims.given_name,
                  prospectLastName: claims.family_name,
                  prospectEmailAddress: usr.userName,
                  prospectUserId: usr.userId,
                  multiLinkId: this.$route.params.multiLinkId
               },
               response: {},
            };
            try {
               const r = await this.$appoint.loadInvitation(payload);
               this.step2 = r.response;
               if (this.step2.agent == null) {
                  this.$swal(
                     "System Error",
                     "The original recruiter who sent the appointment link is terminated/inactive. Please contact support.",
                     "error"
                  )
                  this.$router.push({ name: "home" });
                  return
               }

               if (this.step2.agent.agentType == "C") {
                  this.recruiterName = this.step2.agent.companyName;
               } else {
                  this.recruiterName = this.step2.agent.firstName + " " + this.step2.agent.lastName;
               }
               await this.updateEmailTemplateTypeId(r.response.corrTemplateTypeId);
               if (this.isVBInvitation) {
                  this.aptInd = 'APPTTYP_WVB';
                  this.aptCorp = 'APPTTYP_VB_CORP';
                  this.aptBoth = 'APPTTYP_VB_BOTH';
                  this.aptVBRep = 'APPTTYP_VB_REP';
               }
               else {
                  this.aptInd = 'APPTTYP_IND';
                  this.aptCorp = 'APPTTYP_CORP';
                  this.aptRep = "APPTTYP_REP";
               }

               let levelNo = 0
               let enrollRep = false
               let productTypeCode = ''
               if (this.isMulti) { //multilink invite
                  levelNo = this.step2.multiLinks[0].levelNo
                  productTypeCode = this.step2.multiLinks[0].productTypeCode
                  enrollRep = this.step2.multiLinks[0].enrollRep
               } else { //not a multilink invite
                  levelNo = this.step2.levelNo
                  productTypeCode = this.step2.productTypeCode
                  enrollRep = this.step2.enrollRep
               }

               // REPs skip the wizard
               if (enrollRep) {
                  this.isRep = true;
                  this.appointmentType = "APPTTYP_REP";
               }
               this.invitationLoaded = true
               
            } catch (err) {
               this.busy = false;
               this.$swal(
                  "System Error",
                  "Fetching Agency information failed. Please try again later. If this problem persists please contact support.",
                  "error"
               ).then(() => {
                  this.$router.push({ name: "home" });
                  return;
               });
            }

         },
         handlePrevious() {
            if (this.curstep == 1) return;
            if (this.isRep && this.curstep == 4) this.curstep -= 2;
            else this.curstep -= 1;
         },
         handleNext() {
            switch (this.curstep) {
               case 1:
                  this.curstep += 1;
                  break;
               case 2:
                  if (this.processTwo()) {
                     if (this.isRep) this.curstep += 2;
                     else this.curstep += 1;
                  }
                  break;
               case 3:
                  if (this.processThree()) this.curstep += 1;
                  break;
               case 4:
                  this.processFour();
                  break;
            }
         },
         processTwo() {
            if (this.ynPicked == null) {
               this.$swal("Invitation Look Good?", "Please choose Yes or No", "warning");
               return false;
            }
            if (this.ynPicked != "Y") {
               this.$swal({
                  title: "Are you sure?",
                  text: "Click the 'OK' button if there is a PROBLEM with the invitation. The system will log you out and you can ask the agency that recruited you for a NEW invitation. Click CANCEL if you are not sure.",
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#00a7a1",
                  confirmButtonText: "OK, the invite is bad!",
                  cancelButtonColor: "#000",
                  cancelButtonText: '<i class="fas fa-times"></i> CANCEL',
               }).then(async (result) => {
                  if (result.isConfirmed) {
                     this.busy = true;
                     await this.$appoint.deleteInvite(this.link, this.$store.getters.appUser.userId);
                     await this.$auth.logout();
                     this.busy = false;
                  }
               });
               return false;
            }
            return true;
         },
         processThree() {
            if (this.appointmentType == "") {
               this.$swal(
                  "Appointment Type?",
                  "Please choose one of the appointment types before continuing.",
                  "warning"
               );
               return false;
            }
            return true;
         },
         processFour() {
            let payload

            if (this.isMulti) {
               payload = {
                  init: {
                     recruiter: {
                        name: this.recruiterName,
                        address1: this.step2.agent.address1,
                        address2: this.step2.agent.address2,
                        city: this.step2.agent.city,
                        stateCode: this.step2.agent.state,
                        zipCode: this.step2.agent.zip,
                        phoneNumber: this.step2.agent.phoneNumber,
                        emailAddress: this.step2.agent.emailAddress,
                        agentNumber: this.step2.recruiterAgentNumber,
                        companyNumber: this.step2.recruiterCompanyNumber,
                        blockNumber: this.step2.recruiterBlockNumber,
                     },
                     appointmentTypeCode: this.appointmentType,
                     multiLinkId: this.$route.params.multiLinkId,
                     multiLinks: this.step2.multiLinks
                  }
               }
            } else {
               payload = {
                  init: {
                     recruiter: {
                        name: this.recruiterName,
                        address1: this.step2.agent.address1,
                        address2: this.step2.agent.address2,
                        city: this.step2.agent.city,
                        stateCode: this.step2.agent.state,
                        zipCode: this.step2.agent.zip,
                        phoneNumber: this.step2.agent.phoneNumber,
                        emailAddress: this.step2.agent.emailAddress,
                        agentNumber: this.step2.recruiterAgentNumber,
                        companyNumber: this.step2.recruiterCompanyNumber,
                        blockNumber: this.step2.recruiterBlockNumber,
                     },
                     appointmentTypeCode: this.appointmentType,
                     link: this.link,
                     levelNo: this.step2.levelNo,
                     levelName: this.step2.levelName,
                     documentPath: this.step2.documentPath,
                  },
               };
            }
            this.$router.push({ name: "appoint", params: payload });
         }
      },
   };
</script>

<style scoped lang="scss">
   @import "../assets/css/colors.scss";

   .title-block {
      display: inline-block;
      padding: 6px;
   }

   .wizpage {
      padding: 12px;
   }

   .wizbtn-next {
      background-color: $corp-color;
      color: #fff;
      width: 120px;
   }

   .wizbtn-next:hover {
      color: #000;
   }

   .wizbtn-back {
      color: #fff;
      background-color: #000;
      width: 120px;
   }

   .wizbtn-back:hover {
      color: $corp-orange;
   }

   .indent {
      padding-left: 48px;
      color: $corp-purple;
      font-size: 0.8em;
   }

   .yn {
      padding-left: 48px;
      color: $corp-purple;
   }

   .wiz-icn {
      min-width: 26px;
   }

   .atype-list {
      padding-bottom: 6px;
      list-style-type: square;
      font-size: smaller;
   }

   .skip-link {
      text-decoration: underline !important;
   }

   .doc-view {
      min-height: 600px;
      height: 600px;
      overflow-x: hidden;
      overflow-y: scroll;
      border: 1px solid #ddd;
   }

   .inner-doc-view {
      padding: 0;
      width: 100%;
   }
</style>